import { SideMenuCoordinator } from './SideMenuCoordinator';
import { useJwt } from 'react-jwt';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LoadingLayer } from '../../LoadingLayer';

export const fetchRevisorAbstracts = async (user_groups, setAbstracts) => {
  try {
    const response = await fetch(
        'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/admin/abstracts',
        {
          headers: {
            'user-token': localStorage.getItem('id_token'),
          },
        },
    );
    if (response.status === 401) {
      return response.status;
    }
    const data = await response.json();
    let tempAbstracts = data.Items;
    for (let i = 0; i < tempAbstracts.length; i++) {
      tempAbstracts[i].abstractKey = (
          tempAbstracts[i].category
              .split(' ')
              .map((c) => c[0])
              .join('') +
          '-' +
          (i + 1)
      ).toUpperCase();
    }
    setAbstracts(tempAbstracts);
    return response.status;
  } catch (error) {
    return error;
  }
};

export const CoordinatorHome = () => {
  const [abstracts, setAbstracts] = useState([]);
  const access_token = localStorage.getItem('id_token');
  const { decodedToken } = useJwt(access_token);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState('Loading');

  useEffect(() => {
    console.log('decodedToken');
    console.log(decodedToken);
    if (decodedToken) {
      if (decodedToken['cognito:groups'].includes('revisor')) {
        fetchRevisorAbstracts(decodedToken['cognito:groups'], setAbstracts).then(() => {
          setLoadingMessage('Done');
          setIsLoading(false);
          console.log('abstracts');
        });
      }
    }
  }, [decodedToken]);

  return (
      <div className="snn-user-home-main-wrapper">
        <SideMenuCoordinator />
        <LoadingLayer isLoading={isLoading} action={loadingMessage} />
        <div className="snn-user-home-main-content">
          <h1 className="snn-user-home-main-content-header">Welcome</h1>
          <div className="snn-user-home-main-content-grid">
            <div className="snn-expand-grid-4">
              <div>Pending abstracts to review ({abstracts.length})</div>
              <div></div>
            </div>

            <div className="snn-expand-grid-4">
              {abstracts.map((abstract) => (
                  <Link key={abstract.id} to={`/coordinator/abstracts/${abstract.id}`}>
                    <div
                        className={
                            'snn-abstract-registered-card snn-user-home-abstract-bio' +
                            (abstract.status === 'Submitted'
                                ? ' snn-abstract-registered-card-submitted'
                                : ' snn-abstract-registered-card-draft')
                        }
                    >
                      <p className="snn-user-home-main-content-small-text">{abstract.status}</p>
                      <div className="snn-abstract-registered-card-text">
                        <div className="snn-revisor-card-wrapper-content">
                          <p>{abstract.abstractKey}</p>
                          {abstract.code ? <p>{abstract.code}</p> : null}
                          <p className="snn-user-home-main-content-large-semi">{abstract.title}</p>
                          <div>
                            <p className="snn-user-home-main-content-small-text snn-user-revisor-authors">
                              {abstract.authors.map((a, index) => {
                                if (a.correspondingAuthor) {
                                  if (index > 0) {
                                    return (
                                        <>
                                          <span key={index}>, </span>
                                          <strong key={a.lastName}>
                                            {a.lastName} {a.name.length > 0 ? a.name[0] + '.' : ''}
                                          </strong>
                                          <sup>, *</sup>
                                        </>
                                    );
                                  } else {
                                    return (
                                        <>
                                          <strong key={a.lastName}>
                                            {a.lastName} {a.name.length > 0 ? a.name[0] + '.' : ''}
                                          </strong>
                                          <sup>*</sup>
                                        </>
                                    );
                                  }
                                } else {
                                  if (index > 0) {
                                    return (
                                        <>
                                          <span key={index}>, </span>
                                          <span key={a.lastName}>
                                      {a.lastName} {a.name.length > 0 ? a.name[0] + '.' : ''}
                                    </span>
                                        </>
                                    );
                                  } else {
                                    return (
                                        <span key={a.lastName}>
                                    {a.lastName} {a.name.length > 0 ? a.name[0] + '.' : ''}
                                  </span>
                                    );
                                  }
                                }
                              })}
                            </p>
                            <p>
                              {abstract.authors
                                  .filter((a) => a.correspondingAuthor)
                                  .map((a) => a.email)
                                  .join(', ')}
                            </p>
                            {abstract.score ? (
                                <p>
                                  <strong>Number of revisions: </strong> {abstract.score.length}
                                </p>
                            ) : null}
                            {abstract.accepted ? (
                                <p>
                                  <strong>Already accepted as: </strong> {abstract.accepted}
                                </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
  );
};